import React from "react";
import {
  requestListTutoringProgram,
  useTutoringProgramDispatch,
  useTutoringProgramState,
} from "../../Context";
import { useEffect } from "react";
import TutoringListSkeleton from "../../Components/TutoringListSkeleton";
import { ErrorList } from "../../Components/ErrorList";
import { EmptyList } from "../../Components/EmptyList";
import { Pagination } from "../../Components/Pagination";
import { useState } from "react";
import TutoringCard from "../../Components/TutoringCard";
import { convertToGoogleAnalyticsItem } from "../../Utils";
import { analytics } from "../../firebase";
import { logEvent } from "firebase/analytics";

const TutoringList = () => {
  const tutoringDispatch = useTutoringProgramDispatch();
  const { tutoringList, tutoringListLoading, tutoringListError, nextTokens } =
    useTutoringProgramState();

  const [page, setpage] = useState(1);
  const [filteredtutoringList, setfilteredtutoringList] = useState([]);

  useEffect(() => {
    requestListTutoringProgram(tutoringDispatch, {
      page: 1,
    });
  }, [tutoringDispatch]);

  useEffect(() => {
    const currentDate = new Date();
    const filteredList = tutoringList.filter((item) => {
      return item.schedules.items.some(
        (schedule) => new Date(schedule.scheduledAt) > currentDate
      );
    });

    const analyticsParams = {
      item_list_id: "tutoring",
      item_list_name: "Tutoring Programs",
      items: filteredList.map((tutoring) =>
        convertToGoogleAnalyticsItem({
          ...tutoring,
          name: tutoring.title,
          type: "tutoring",
        })
      ),
    };
    logEvent(analytics, "view_item_list", analyticsParams);

    setfilteredtutoringList(filteredList);
  }, [tutoringList]);

  const onNext = () => {
    const nextPage = page + 1;
    setpage(nextPage);
    if (nextTokens[nextPage]) {
      requestListTutoringProgram(tutoringDispatch, {
        page: nextPage,
        nextToken: nextTokens[nextPage],
      });
    }
  };

  const onPrev = () => {
    const prevPage = page - 1;
    setpage(prevPage);
    if (prevPage > 0) {
      requestListTutoringProgram(tutoringDispatch, {
        page: prevPage,
        nextToken: nextTokens[prevPage],
      });
    }
  };

  const onPageChange = (selectedPage) => {
    setpage(selectedPage);
    if (nextTokens[selectedPage] || selectedPage === 1) {
      requestListTutoringProgram(tutoringDispatch, {
        page: selectedPage,
        nextToken: nextTokens[selectedPage],
      });
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        <div className="bg-white shadow-sm max-w-7xl mx-auto overflow-hidden px-4 py-6 sm:px-6 rounded-t-lg">
          {tutoringListLoading ? (
            <TutoringListSkeleton totalItem={4} />
          ) : (
            <div className="flex flex-col gap-4">
              {filteredtutoringList.length > 0 ? (
                <div className="-mx-px grid grid-cols-1 sm:grid-cols-2 sm:mx-0 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {filteredtutoringList.map((item) => {
                    return (
                      <a
                        key={item.id}
                        href={`/tutoring/detail/${item.id}`}
                        className="flex border border-gray-200 rounded-lg p-4"
                      >
                        <TutoringCard item={item} />
                      </a>
                    );
                  })}
                </div>
              ) : tutoringListError ? (
                <ErrorList
                  message={
                    tutoringListError?.message || "Error fetching class."
                  }
                  errors={tutoringListError?.errors}
                />
              ) : (
                <EmptyList
                  className="flex items-center justify-center"
                  title="No Tutoring Program"
                />
              )}
            </div>
          )}
        </div>
        <Pagination
          className="rounded-b-lg"
          page={page}
          onPrev={onPrev}
          onNext={onNext}
          onPageChange={onPageChange}
          nextTokens={nextTokens}
        />
      </div>
    </div>
  );
};
export default TutoringList;
